import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useParams } from '@reach/router'
import { Grid, Tooltip } from '@mui/material'
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'

import { getProblemsListSelector } from '_/modules/service-orders/selectors'
import { categoriesSelector } from '_modules/categories/selectors'
import { getProblemList } from '_/modules/service-orders/actions'

import { getCategories } from '_modules/categories/actions'

import { BasicInput } from '_/components/inputs'

import useStyles from '../styles'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

const NAME = 'problem'

export function ProblemField() {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { serviceOrderId } = useParams()

  const problemsList = useSelector(getProblemsListSelector)
  const categoriesList = useSelector(categoriesSelector)

  const { addProblemReadOnly, budgetResolutionToEdit } = useBudgetForm()

  useEffect(() => {
    if (!problemsList) dispatch(getProblemList({ serviceOrder: serviceOrderId, active: true }))
  }, [problemsList])

  useEffect(() => {
    if (!categoriesList.length) dispatch(getCategories())
  }, [])

  return (
    <Grid className={styles.problemContainer}>
      <BasicInput
        defaultValue={budgetResolutionToEdit?.problemText || ''}
        name={NAME}
        label={
          <div className={styles.descriptionLabel}>
            Descrição do serviço
            <Tooltip
              title="Campo para você inserir um texto de simples referência para este serviço, facilitando importá-lo para outros orçamentos."
              arrow
            >
              <HelpOutlineOutlinedIcon className={styles.tooltipIcon} />
            </Tooltip>
          </div>
        }
        placeholder="Problema"
        style={{ width: '100%' }}
        disabled={addProblemReadOnly}
        labelClasses={styles.label}
        required
      />
    </Grid>
  )
}
